<template>
	<div class="full">
		<el-tabs class="full flex" style="flex-direction: column;" v-model="activeName" type="card">
			<el-tab-pane label="订单信息" name="detail">
				<div class="pane_container">
					<detail :row="row"  :key="'detail'+key" />
				</div>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>
<style scoped>
	.pane_container {
		position: relative;
		width: 100%;
		height: 100%;
		box-sizing: border-box;
		padding: 0px;
		overflow-y: auto;
		overflow-x: hidden;
		box-sizing: border-box;
	}
</style>
<script>
	import detail from './detail.vue';
	export default {
		props: {
			list: {
				default: () => {
					return null
				}
			},
			row: {
				type: Object,
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				activeName: 'detail',
				key: Math.random(),
				
			}
		},
		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			onSubmit() {
				console.log('submit!');
			},
			inittab() {
				this.key = Math.random()
			}
		},
		components: {
			detail,
		}
	}
</script>
